import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {ProductLineItem} from "../product-line-items/types.ts";


export enum ProductStatus {
    Active = 'Active',
    Deprecated = 'Deprecated',
    Draft = 'Draft'
}


export type Product = {
    id: string,
    name: string,
    status: ProductStatus,
    shortDescription?: string,
    longDescription?: string,
    productImage?: string,
    billingProviderId?: string,
    billingProviderRecordId?: string,
    current?: boolean,
    baseFee?: string,
    included?: string,
    lineItems?: {
        items: ProductLineItem[],
        nextToken: string | null
    },
    freeTrial?: boolean
    createdByUsername?: string,
    createdByUser?: { username: string, givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IProductTableColumn extends ITableColumn {
    render?: (item: Product) => ReactNode;
}


export type ListProducts = {
    listProducts: {
        items: Product[],
        nextToken: string
    }
}

export type GetProduct = {
    getProduct: Product
}

export type CreateProduct = {
    createProduct: Product
}

export type UpdateProduct = {
    updateProduct: Product
}

export type CloneProduct = {
    cloneProduct: Product
}

export type DeleteProduct = {
    deleteProduct: string
}

